import { DEV_MODE } from '@cob/ui-genesis/helpers/cob.devmode.js';
import DefinitionFieldsP from './recordm.presenter.definition.fields.js';
import DefinitionFieldsV from '../view/recordm.view.definition.fields.js';
import FieldErrorM from '../helpers/model.def-field-error.js';

var DefinitionP = function(core, definitionM, view) {

    var
    // Presenter for the fields part of the definition. (everything bellow the save/cancel bar)
        _definitionFieldsP,

    // Can we edit the definition? Only if it's a new Def or If it has the update _link
        _isReadOnly = false;

    view.init({

        save: function (reIndex) {
            view.updateModel(definitionM);
            _definitionFieldsP.updateModel(definitionM);

            DEV_MODE && window.console.log("saving definition");
            definitionM.sync(definitionM.data, {
                success: function () {
                    if(reIndex) definitionM.index(true);
                    core.navigateBack();
                },
                fieldError: function (errors) {
                    const translated = new FieldErrorM(core, errors).getTranslatedErrors();
                    const grouped = translated.reduce(
                        (acc, e) => {
                            const key = e.id || e.name
                            acc[key] =  acc[key] || [];
                            acc[key].push(e);
                            return acc
                        } ,
                        {}
                    );
                    // show name & description errors
                    view.showErrors(grouped);
                    // show field errors
                    _definitionFieldsP.showErrors(grouped)
                }
            });
        },

        cancel: function () {
            core.navigateBack();
        },

        // Change to the edit states mode
        edit_states: function () {
            //todo jone implementar mudar para os estados
        },

        // Change to the edit fields mode
        edit_fields: function () {
            //todo jone implementar o voltar aos campos
        }
    });

    var _init = function () {
        _startSubscribers();

        if (definitionM.data.id) {
            _isReadOnly = definitionM.data._links && definitionM.data._links.update === undefined;
        }

        _showDefinition();
    };

    var _startSubscribers = function () {
        core.subscribe(definitionM.update_event_name, _showDefinition);
    };

    var _stopSubscribers = function () {
        core.unsubscribe(definitionM.update_event_name, _showDefinition);
    };

    var _showDefinition = function () {
        var data = definitionM.data;

        view.showDefinition(data, _isReadOnly);

        _definitionFieldsP = new DefinitionFieldsP(
            core,
            new DefinitionFieldsV(core, view.getFieldsContainer())
        );

        if (data.fieldDefinitions) {
            _definitionFieldsP.showFields(data.fieldDefinitions, _isReadOnly);
        }
    };

    var _destroy = function () {
        view.destroy();

        _stopSubscribers()
    };

    return{
        init: _init,
        pause: _stopSubscribers,
        resume: _startSubscribers,
        destroy: _destroy
    };
};

export default DefinitionP;
